/**
 * Tipos das telas de campanha — o contrato com /api/v1/campanhas.
 */

import type { Etapa } from '@egba-do/shared'

export interface Metricas {
  enviados: number
  bloqueados: number
  falhas: number
  cliques: number
  conversoes: number
}

export interface PassoFluxo {
  tipo: string
  canal?: string
  minutos?: number
}

export interface DefinicaoPublico {
  categoriaId?: string
  segmento?: string[]
  inep?: boolean
  uf?: string[]
  municipio?: string[]
  estagio?: string[]
  origem?: string[]
  canal?: 'email' | 'sms' | 'whatsapp'
}

export interface Campanha {
  id: string
  nome: string
  objetivo: string | null
  status: string
  classeComunicacao: string
  categoriaId: string | null
  publicoAlvo: DefinicaoPublico
  criadoEm: string
  atualizadoEm: string
  metricas: Metricas
  execucoes: { naRegua: number; emAndamento: number }
  etapas: number
  fluxo: PassoFluxo[]
}

export interface Detalhe {
  id: string
  nome: string
  objetivo: string | null
  status: string
  classeComunicacao: string
  categoriaId: string | null
  publicoAlvo: DefinicaoPublico
  criadoEm: string
  atualizadoEm: string
  etapas: Etapa[]
  execucoes: { agendadas: number; concluidas: number; erros: number; total: number }
  metricas: Metricas
  canais: Array<{ canal: string; disponivel: boolean; provedor: string; motivo: string | null }>
}

export interface ResumoPublico {
  total: number
  comEmail: number
  comTelefone: number
  optinEmail: number
  optinWhatsapp: number
}

export interface AmostraLead {
  id: string
  nome: string | null
  razaoSocial: string | null
  email: string | null
  telefone: string | null
  municipio: string | null
  uf: string | null
  estagio: string
  optinEmail: boolean
  optinWhatsapp: boolean
}

export interface ResultadoSimulacao {
  resumo: ResumoPublico
  enviados: number
  bloqueados: number
  falhas: number
  porMotivo: Record<string, number>
  bloqueioEleitoral: { motivo: string; fundamento: string } | null
}

export interface Envio {
  id: string
  leadId: string
  canal: string
  classeComunicacao: string | null
  assunto: string | null
  status: string
  motivoBloqueio: string | null
  provedor: string | null
  criadoEm: string
  enviadoEm: string | null
  clicadoEm: string | null
  convertidoEm: string | null
  lead: { nome: string | null; email: string | null; razaoSocial: string | null } | null
}

export const TONS_STATUS: Record<string, 'neutro' | 'sucesso' | 'atencao' | 'perigo'> = {
  rascunho: 'neutro',
  ativa: 'sucesso',
  pausada: 'atencao',
  encerrada: 'neutro',
}

export const NOMES_MOTIVO: Record<string, string> = {
  sem_contato: 'sem contato para o canal',
  sem_optin: 'sem opt-in do canal',
  sem_optin_whatsapp: 'sem opt-in de WhatsApp',
  supressao: 'na lista de supressão',
  canal_indisponivel: 'canal sem provedor configurado',
  falha_provedor: 'recusado pelo provedor',
  classe_vedada_na_janela: 'classe vedada na janela eleitoral',
  sem_classificacao: 'peça sem classificação',
  configuracao_invalida: 'configuração eleitoral inválida',
}

export function n(v: number): string {
  return new Intl.NumberFormat('pt-BR').format(v)
}
